import { render, staticRenderFns } from "./obs_assistente.vue?vue&type=template&id=0e669a83&scoped=true"
import script from "./obs_assistente.vue?vue&type=script&lang=js"
export * from "./obs_assistente.vue?vue&type=script&lang=js"
import style0 from "./obs_assistente.vue?vue&type=style&index=0&id=0e669a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e669a83",
  null
  
)

export default component.exports